export default "__VITE_ASSET__DmdU4nns__"